import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import classNames from 'classnames';
import SharedCard from './components/SharedCard';

const skeletonObj = {
  id: 1,
  title: 'Texto de propiedad',
  address: `Texto para la dirección`,
  barrios: 'Texto para el barrio',
  price: 'Texto para el precio',
  expenses: 'Texto para las expensas',
  operation: `Operacion`,
  updated_at: 'Texto para la fecha',
  created_at: 'Texto para la fecha',
  type: 'Texto para el tipo',
  locality: 'Texto para la localidad',
  characteristics: {
    ambience: 10,
    bedrooms: 10,
    bathrooms: 10,
    toilettes: 10,
    garages: 10,
    floors: 10
  },
  share: {
    active: true,
    percent: 50
  },
  surface: {
    totalSurface: 10,
    coveredSurface: 10
  },
  real_estate: {
    name: 'Texto para la inmobiliaria',
    branchOffice: [
      {
        id: 1,
        branch_office_name: 'Texto para Sucursal',
        isCentral: false,
        isActive: true,
        phoneNumber: '1234567890',
        openingHours: 'Texto para el horario',
        address: 'Texto para la dirección'
      }
    ]
  }
};

const SharedCards = ({
  properties,
  length,
  loading,
  propsLimit,
  selected,
  setSelected
}) => {
  const skeletonArr = Array(propsLimit).fill(skeletonObj);

  return (
    <Row>
      {!loading ? (
        length > 0 ? (
          properties.map(property => (
            <Col key={property.id} xs={12} sm={6} xxl={3}>
              <SharedCard
                prop={property}
                selected={selected}
                setSelected={setSelected}
              />
            </Col>
          ))
        ) : (
          <Col xs={12}>
            <Card
              className="bg-white"
              style={{
                borderLeft: `5px solid var(--falcon-lighten-secondary)`
              }}
            >
              <Card.Body>
                <Col xs={12} className="d-flex">
                  <Row>
                    <Col xs={12}>
                      <h5 className="d-block fw-bold m-0">
                        Sin propiedades para mostrar.
                      </h5>
                    </Col>
                  </Row>
                </Col>
              </Card.Body>
            </Card>
          </Col>
        )
      ) : (
        skeletonArr.map((property, index) => (
          <Col key={index} xs={12} sm={6} xxl={3}>
            <SharedCard prop={property} loading />
          </Col>
        ))
      )}
    </Row>
  );
};

SharedCards.propTypes = {
  properties: PropTypes.array,
  length: PropTypes.number,
  loading: PropTypes.bool,
  propsLimit: PropTypes.number.isRequired,
  selected: PropTypes.array,
  setSelected: PropTypes.func
};

export default SharedCards;
